function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.889 8.832)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.034,15.084v-6.9a1.726,1.726,0,0,0-.863-1.493L13.13,3.234a1.726,1.726,0,0,0-1.726,0L5.363,6.686A1.726,1.726,0,0,0,4.5,8.179v6.9a1.726,1.726,0,0,0,.863,1.493L11.4,20.029a1.726,1.726,0,0,0,1.726,0l6.041-3.452A1.726,1.726,0,0,0,20.034,15.084Z",
  transform: "translate(-4.5 -3.003)",
  fill: "none",
  stroke: "#00404f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.9,10.44,12.439,14.8l7.534-4.358",
  transform: "translate(-4.672 -6.161)",
  fill: "none",
  stroke: "#00404f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,26.7V18",
  transform: "translate(-10.233 -9.372)",
  fill: "none",
  stroke: "#00404f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M258.646,239.609a13.883,13.883,0,1,1-7.106-1.962",
  transform: "translate(-243.786 -243.549)",
  fill: "none",
  stroke: "#00404f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0,2.42,2.42,4.84,0",
  transform: "translate(14.476 -6.574) rotate(114)",
  fill: "none",
  stroke: "#00404f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

var SvgRefound = function SvgRefound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.286,
    height: 31.611,
    viewBox: "0 0 29.286 31.611",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Refound.4c916d81.svg";
export { ForwardRef as ReactComponent };